export const scrapsReducer = (
  state = {
    scraps: [],
    scrapsMeta: { total: 0, page: 1, limit: 100, totalPages: 1 },
    loadingScraps: false,
    scrap: {},
    savingScrap: false,
    deletingScrap: false,
    bulkUploading: false,
    bulkHistory: [],
    bulkHistoryLoading: false,
  },
  action
) => {
  switch (action.type) {
    case "GETTING_ALL_SCRAPS":
      return { ...state, loadingScraps: true };

    case "GOT_ALL_SCRAPS":
      return {
        ...state,
        scraps: action.payload,
        scrapsMeta: action.meta || state.scrapsMeta,
        loadingScraps: false,
      };

    case "CANNOT_GET_ALL_SCRAPS":
      return { ...state, loadingScraps: false };

    case "GETTING_SCRAP":
      return { ...state, loadingScrap: true };

    case "GOT_SCRAP":
      return { ...state, scrap: action.payload, loadingScrap: false };

    case "CANNOT_GET_SCRAP":
      return { ...state, loadingScrap: false };

    case "CREATING_SCRAP":
    case "UPDATING_SCRAP":
      return { ...state, savingScrap: true };

    case "CREATED_SCRAP":
    case "UPDATED_SCRAP":
    case "CANNOT_CREATE_SCRAP":
    case "CANNOT_UPDATE_SCRAP":
      return { ...state, savingScrap: false };

    case "DELETING_SCRAP":
      return { ...state, deletingScrap: true };

    case "DELETED_SCRAP":
    case "CANNOT_DELETE_SCRAP":
      return { ...state, deletingScrap: false };

    case "BULK_UPLOADING_SCRAPS":
      return { ...state, bulkUploading: true };

    case "BULK_UPLOADED_SCRAPS":
    case "CANNOT_BULK_UPLOAD_SCRAPS":
      return { ...state, bulkUploading: false };

    case "GETTING_SCRAP_BULK_HISTORY":
      return { ...state, bulkHistoryLoading: true };

    case "GOT_SCRAP_BULK_HISTORY":
      return {
        ...state,
        bulkHistory: action.payload,
        bulkHistoryLoading: false,
      };

    case "CANNOT_GET_SCRAP_BULK_HISTORY":
      return { ...state, bulkHistoryLoading: false };

    default:
      return state;
  }
};
